import { matchPath, NavLink, useLocation } from "react-router-dom";
import logo from "@/assets/app-logo.svg";
import Menubar from "./MenuBar";
import ProfileButton from "./ProfileButton";
import TabBar from "./TabBar";

const HeaderWithMenubar = () => {
  const location = useLocation();
  // Profile/conversation routes render as full-screen sheets on mobile that
  // cover the header and TabBar, so they no longer need to be hidden here —
  // unmounting them would reflow the page beneath the sheet mid-animation.
  const shouldHideMobileHeader = !!matchPath("/upgrade", location.pathname);

  return (
    <>
      <header
        className={`${
          shouldHideMobileHeader ? "hidden md:flex" : "flex"
        } md:fixed justify-between items-center px-4 md:px-8 py-2 md:pt-4 bg-black w-full z-20`}
      >
        <div className="flex items-center">
          <NavLink to="/">
            <img
              src={logo}
              alt="Pulse Logo"
              className="h-7 w-7 md:w-8 md:h-8 mr-2 transition-transform duration-300 active:scale-125"
            />
          </NavLink>
        </div>
        <div className="hidden md:block flex-grow">
          <Menubar />
        </div>
        <ProfileButton />
      </header>
      <div className="hidden md:flex h-16 bg-black" />
      {!shouldHideMobileHeader && <TabBar />}
    </>
  );
};

export default HeaderWithMenubar;
